import { RouteItem } from '@eastcoal/router/types/route'

import {
  TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH,
  TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH
} from './constants/path'

export const transactionAnnouncementRoute: RouteItem = {
  title: '成交公告',
  hideInMenu: true,
  children: [
    {
      title: '列表',
      path: TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '详情',
      path: TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH,
      Component: () => import('./Detail/index')
    }
  ]
}
